import "./DESetup.scss";
import { Link } from "react-router-dom";
import { FiEdit, FiDownload } from "react-icons/fi";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import Modal from "../../ReuseableComponents/Modal/Modal";
import DeleteLawDocument from "./SearchDocument/DeleteDocuments/DeleteLawDocument";
import { useState } from "react";
import Loader from "../../ReuseableComponents/Loader/Loader";
import { MdEdit } from "react-icons/md";
import HistoricalText from "./Text/HistoricText";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";
import HL4 from "../../../assests/images/HL/HL4.png";
import HL3 from "../../../assests/images/HL/HL3.jpeg";
import HL2 from "../../../assests/images/HL/HL2.png";
import HL1 from "../../../assests/images/HL/HL1.png";

export interface StaffProps {
  isStaff: any;
  historyrLaw: any;
  loading: any;
  setLoading: any;
  webTemplate: any;
  handleButtonClick: any;
  disabledButtons: any;
  cursor: any;
}

const HistoricalLaws = ({
  isStaff,
  historyrLaw,
  loading,
  setLoading,
  webTemplate,
  handleButtonClick,
  disabledButtons,
  cursor,
}: StaffProps) => {
  let img: any;
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [showTextModal, setShowTextModal] = useState(false);
  const [note, setNote] = useState<any>();
  const [docView, setDocView] = useState(false);
  const [onDemandData, setOnDemandData] = useState<any>();
  const [demandLoading, setDemandLoading] = useState(false);

  const handleOpenDeleteModal = () => {
    setDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleOpenTextModal = () => {
    setShowTextModal(true);
    setNote(webTemplate?.historical_laws_body_en);
  };

  const handleCloseTextModal = () => {
    setShowTextModal(false);
  };
  return (
    <div className="basic-laws-container">
      <div className="headings">
        <div className="topline">
          <h1>Historical Laws</h1>
          <Link
            to="/upload-documents-en"
            style={{ display: isStaff ? "flex" : "none" }}
          >
            <button className="add-new">Add New</button>
          </Link>
        </div>
        <div className="topline">
          <p>
            {webTemplate?.historical_laws_body_en}{" "}
            <MdEdit
              style={{ display: isStaff ? "inline-block" : "none" }}
              className="edit-icon"
              onClick={handleOpenTextModal}
            />
          </p>
          {docView ? (
            <div className="togle">
              <h4 className="toggle-title">GRID</h4>
              <BsToggleOff
                className="toggle-icon"
                onClick={() => setDocView(false)}
              />
            </div>
          ) : (
            <div className="togle">
              <h4 className="toggle-title">CAROUSEL</h4>
              <BsToggleOn
                className="toggle-icon"
                onClick={() => setDocView(true)}
              />
            </div>
          )}
        </div>
      </div>
      {/* <div className="popular-laws"> */}
      {loading ? (
        <>
          <Loader width={330} />
          <h4
            style={{
              textAlign: "center",
              color: "#083052",
              fontSize: "16px",
              margin: 0,
            }}
          >
            Searching for Historical Laws
          </h4>
        </>
      ) : (
        <>
          {docView ? (
            <div className="basic-laws">
              {historyrLaw?.map((items: any) => {
                if (items?.id === 10610) {
                  img = HL4;
                } else if (items?.id === 10609) {
                  img = HL3;
                } else if (items?.id === 10608) {
                  img = HL2;
                } else {
                  img = HL1;
                }
                return (
                  <div className="basic-laws-card" key={items?.id}>
                    <img src={img} alt="HistoricalLaw" />
                    <h3>{items?.name.slice(0, 90)}</h3>
                    <div
                      className="card-buttons"
                      style={{ display: isStaff ? "flex" : "none" }}
                    >
                      {items?.file !== null ? (
                        <a
                          href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <AiOutlineEye /> / <FiDownload />
                        </a>
                      ) : (
                        <>
                          {demandLoading && onDemandData.id === items.id ? (
                            <div>
                              <Loader width={60} />
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "#fff",
                                  fontSize: "12px",
                                }}
                              >
                                Downloading
                              </p>
                            </div>
                          ) : (
                            <button
                              style={{ cursor: cursor }}
                              className="download-button"
                              key={items.doc_id}
                              onClick={() => handleButtonClick(items)}
                              disabled={disabledButtons.some(
                                (button: any) =>
                                  button.doc_id === items.doc_id
                              )}
                            >
                              <AiOutlineEye /> / <FiDownload />
                            </button>
                          )}
                        </>
                      )}
                      <Link to={`/update-documents-en?id=${items.id}`}>
                        <FiEdit />
                      </Link>
                      <button
                        className="delete-button"
                        onClick={() => {
                          handleOpenDeleteModal();
                          setDeleteID(items?.id);
                        }}
                      >
                        <AiOutlineDelete />
                      </button>
                    </div>
                    <div
                      className="card-buttons"
                      style={{ display: isStaff ? "none" : "flex" }}
                    >
                      {items?.file !== null ? (
                        <a
                          href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="view-download"
                        >
                          View / Download
                        </a>
                      ) : (
                        <>
                          {demandLoading && onDemandData.id === items.id ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <Loader width="" />
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "#fff",
                                  fontSize: "12px",
                                  margin: 0,
                                }}
                              >
                                Downloading
                              </p>
                            </div>
                          ) : (
                            <button
                              style={{ cursor: cursor }}
                              className="download-button"
                              key={items.doc_id}
                              onClick={() => handleButtonClick(items)}
                              disabled={disabledButtons.some(
                                (button: any) =>
                                  button.doc_id === items.doc_id
                              )}
                            >
                              View / Download
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <Swiper
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                1200: {
                  slidesPerView: 4,
                },
                990: {
                  slidesPerView: 3,
                },
                600: {
                  slidesPerView: 2,
                },
              }}
              navigation={true}
              modules={[Autoplay, Navigation]}
              className="mySwiper"
            >
              <div className="basic-laws">
                {historyrLaw?.map((items: any) => {
                if (items?.id === 10610) {
                  img = HL4;
                } else if (items?.id === 10609) {
                  img = HL3;
                } else if (items?.id === 10608) {
                  img = HL2;
                } else {
                  img = HL1;
                }
                  return (
                    <SwiperSlide>
                      <div className="basic-laws-card" key={items?.id}>
                        <img src={img} alt="HistoricalLaw" />
                        <h3>{items?.name.slice(0, 90)}</h3>
                        <div
                          className="card-buttons"
                          style={{ display: isStaff ? "flex" : "none" }}
                        >
                          {items?.file !== null ? (
                            <a
                              href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <AiOutlineEye /> / <FiDownload />
                            </a>
                          ) : (
                            <>
                              {demandLoading && onDemandData.id === items.id ? (
                                <div>
                                  <Loader width={60} />
                                  <p
                                    style={{
                                      textAlign: "center",
                                      color: "#fff",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Downloading
                                  </p>
                                </div>
                              ) : (
                                <button
                                  style={{ cursor: cursor }}
                                  className="download-button"
                                  key={items.doc_id}
                                  onClick={() => handleButtonClick(items)}
                                  disabled={disabledButtons.some(
                                    (button: any) =>
                                      button.doc_id === items.doc_id
                                  )}
                                >
                                  <AiOutlineEye /> / <FiDownload />
                                </button>
                              )}
                            </>
                          )}
                          <Link to={`/update-documents-en?id=${items.id}`}>
                            <FiEdit />
                          </Link>
                          <button
                            className="delete-button"
                            onClick={() => {
                              handleOpenDeleteModal();
                              setDeleteID(items?.id);
                            }}
                          >
                            <AiOutlineDelete />
                          </button>
                        </div>
                        <div
                          className="card-buttons"
                          style={{ display: isStaff ? "none" : "flex" }}
                        >
                          {items?.file !== null ? (
                            <a
                              href={`https://aqcheckin.s3.amazonaws.com${items?.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="view-download"
                            >
                              View / Download
                            </a>
                          ) : (
                            <>
                              {demandLoading && onDemandData.id === items.id ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    width: "100%",
                                  }}
                                >
                                  <Loader width="" />
                                  <p
                                    style={{
                                      textAlign: "center",
                                      color: "#fff",
                                      fontSize: "12px",
                                      margin: 0,
                                    }}
                                  >
                                    Downloading
                                  </p>
                                </div>
                              ) : (
                                <button
                                  style={{ cursor: cursor }}
                                  className="download-button"
                                  key={items.doc_id}
                                  onClick={() => handleButtonClick(items)}
                                  disabled={disabledButtons.some(
                                    (button: any) =>
                                      button.doc_id === items.doc_id
                                  )}
                                >
                                  View / Download
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </div>
            </Swiper>
          )}
        </>
      )}
      <div className="col-md-3">
        {showDeleteModal && (
          <Modal
            title="Delete Document"
            content={
              <DeleteLawDocument
                handleCloseDeleteModal={handleCloseDeleteModal}
                deleteID={deleteID}
              />
            }
            onClose={handleCloseDeleteModal}
          />
        )}
      </div>
      <div className="col-md-3">
        {showTextModal && (
          <Modal
            title="Update Text"
            content={
              <HistoricalText
                note={note}
                setNote={setNote}
                handleCloseTextModal={handleCloseTextModal}
                loading={loading}
                setLoading={setLoading}
              />
            }
            onClose={handleCloseTextModal}
          />
        )}
      </div>
    </div>
  );
};

export default HistoricalLaws;
